import { notify as publicNotify } from './ping-notifications-v3-notification-notifications-v-3.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const notify: MaybeContext<
  BuildRESTFunction<typeof publicNotify> & typeof publicNotify
> = /*#__PURE__*/ createRESTModule(publicNotify);

export { TemplateChannel } from './ping-notifications-v3-notification-notifications-v-3.universal.js';
export {
  Notification,
  NotifyRequest,
  DynamicValue,
  DynamicValueOfTypeOneOf,
  Money,
  MapDynamicValue,
  ArrayDynamicValue,
  AttachmentDynamicValue,
  NotifyResponse,
  NotifyByAppRequest,
  Overrides,
  ExcludedAudiences,
  ChannelsContent,
  MobileContent,
  ChannelsData,
  EmailData,
  NotifyByAppResponse,
  ResolveRequest,
  ResolveResponse,
  NotifyOptions,
} from './ping-notifications-v3-notification-notifications-v-3.universal.js';
export { TemplateChannelWithLiterals } from './ping-notifications-v3-notification-notifications-v-3.universal.js';
